import React from 'react';
import { Row, Col, Layout } from 'antd';
import Logo from '../images/logo.png';
import Krestonlogo from '../images/kreston-logo.png';

import LandingForm from '../components/LandingPage/LandingForm';
import SEO from '../components/seo';
import SEOImage from '../images/share.jpg';

// Style
import styles from './LandingPage.module.scss';

const { Content } = Layout;

function LandingPage() {
  return (
    <React.Fragment>
      <SEO title="Portail Exco COVID | Accueil" image={SEOImage} />
      <Content>
        <Row>
          <Col lg={12} xl={12} sm={24} xs={24}>
            <div className={styles.formContainer}>
              <div className={styles.wrapper}>
                <a
                  href="https://www.exco-tunisie.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={styles.logo}
                    src={Logo}
                    alt="Exco COVID logo"
                  />
                </a>
                <h1 className={styles.title}>
                  Bienvenue dans le portail <br /> d’information Exco COVID-19.
                </h1>
                <LandingForm />
              </div>
              <img
                className={styles.kreston}
                src={Krestonlogo}
                alt="kreston logo"
              ></img>
            </div>
          </Col>
          <Col lg={12} xl={12} sm={24} xs={24}>
            <div className={styles.background}></div>
          </Col>
        </Row>
      </Content>
    </React.Fragment>
  );
}
export default LandingPage;
